import { DropdownInputPropsType } from "types/form-types";

const DropdownItemInput = <T, TSort> (props: DropdownInputPropsType<T, TSort> & {
    onItemClick: (i: T, event: React.MouseEvent<HTMLLIElement> | React.KeyboardEvent<HTMLLIElement>) => void,
    isActive: boolean,
    isFocused: boolean,
    item: T
}) => {
    const value = typeof props.view.dropdownView == 'function' ? props.view.dropdownView(props.item) : props.view.inputView(props.item);
    const className = `link ${props.isActive ? 'active' : ''} ${props.isFocused ? 'focus' : ''}`.trim();

    const onKeyPress = (event: React.KeyboardEvent<HTMLLIElement>) => {
        event.preventDefault();
        event.stopPropagation();

        if(['Enter', 'Tab', ' '].indexOf(event.key) > -1) {
            props.onItemClick(props.item, event);
        }
    }

    return (
        <li tabIndex={0} className={className}
            onClick={e => props.onItemClick(props.item, e)}
            onKeyUp={onKeyPress}
        >
            {value}
        </li>
    );
}

export default DropdownItemInput;
